<template>
  <div class="container">
    <header class="jumbotron">
      <h3>Home</h3>
    </header>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: "Home",
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    
  },
};
</script>
